import { authentificationRepository } from '../repositories/authentication-repository';

async function signIn(token) {
    if (!token) {
        throw Error('Invalid token parameter');
    }

    return authentificationRepository.signIn(token);
}

export {
    signIn
};
